export { ViewInstrumentation } from './instrumentation';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/view/index.ts